/**   
 * api接口统一管理
 */
import { get, post } from './setting'

const user_api = {
    userinfo : '/api/Recruit/GetUserInfo17',
    queryplayer : '/api/user/getNickName',
    bind : '/api/user/bind',
    share : '/api/share/getCode?mode=2',//网页分享 mode:1 招募 ，2助力
    invite : '/api/share/getCode?mode=1',//邀请组队
    apply_list : '/api/share/GetListByMode',//申请列表 mode,模块，可空默认0
    share_apply : '/api/share/bindCode',//助力同意 
    invite_apply : '/api/share/bindCode',
    invite_info : '/api/share/getNickName',//邀请人信息
    score_info : '/api/user/score',//积分信息
    task_info : '/api/UserTask/GetDict?s=true',//任务信息
    task_apply : '/api/UserTask/RwTaskIds',//任务领奖 orderId
}

//任务信息
// t01：招募神兵
// t02：积分解锁
// t03：招募消费
// t04：助力神兵

export const apiUserInfo = p => get(user_api.userinfo, p);
export const apiUserQuery = p => get(user_api.queryplayer, p);
export const apiUserBind = p => post(user_api.bind, p);
export const apiScoreInfo = p => get(user_api.score_info, p);
export const apiTaskInfo = p => get(user_api.task_info, p);
export const apiTaskApply = p => post(user_api.task_apply, p);
export const apiShare = p => get(user_api.share, p);
export const apiInvite = p => get(user_api.invite, p);
export const apiInviteApply = p => post(user_api.invite_apply, p);
export const apiInviteInfo = p => get(user_api.invite_info, p);
export const apiShareApply  = p => post(user_api.share_apply, p);
export const apiInviteList = p => get(user_api.apply_list, p);